import React from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { Form } from "@carrotfertility/carotene-core-x"
import { StepButtons } from "#/components/carrot-card-cost-share/steps/shared/StepButtons"
import { RadioGroupStepProps } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { FormRadioButtonGroup } from "#/services/common-forms"

interface RadioGroupWithTileStepProps extends RadioGroupStepProps {
  children: React.ReactNode | React.ReactNode[]
}

export function RadioGroupWithTileStep({
  title,
  description,
  name,
  options,
  onSubmit,
  defaultValue,
  children
}: RadioGroupWithTileStepProps): JSX.Element {
  const { back } = useStateMachine()

  return (
    <Box>
      <Typography id={`${name}-title`} variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.sm })}>
        {title}
      </Typography>

      <Typography sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.lg })}>{description}</Typography>

      <Form onSubmit={onSubmit} defaultValues={{ [name]: defaultValue }}>
        <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.tokens.spacing.xl })}>
          <FormRadioButtonGroup name={name} aria-labelledby={`${name}-title`} options={options} />
          {children}
          <StepButtons selectName={name} back={back} />
        </Box>
      </Form>
    </Box>
  )
}
